<div class="drop-down-item" [class.selected]="highlighted" [class.disabled]="item.disabled" [matTooltip]="item.disabledReason" [matTooltipDisabled]="!item.disabled || !item.disabledReason" (click)="selected.emit()">
  @if (type === "item") {
    @if (item.avatar) {
      <img class="small-avatar" [src]="item.avatar" />
    }
    @if (item.icon) {
      <img [src]="item.icon" />
    }
    @if (!item.avatar && !item.icon && item.checkbox !== "none") {
      <flow-checkbox-v2 [radio]="item.checkbox === 'radio'" [checked]="isSelected"></flow-checkbox-v2>
    }
    @if (item.subtitle) {
      <div class="title-with-subtitle">
        <p agText="body-3">
          {{ item.title }}
        </p>
        <p agText="caption-1" class="subtitle">
          {{ item.subtitle }}
        </p>
      </div>
    } @else {
      <p agText="body-3">
        {{ item.title }}
      </p>
    }
    @if ((item.avatar || item.icon) && item.checkbox !== "none") {
      <flow-checkbox-v2 [style.margin-left]="'auto'" [radio]="item.checkbox === 'radio'" [checked]="isSelected"></flow-checkbox-v2>
    }
  } @else if (type === "phone-number") {
    @if (item.subtitle) {
      <div class="title-with-subtitle">
        <p agText="body-3">
          {{ item.title }}
        </p>
        <p agText="caption-1" class="subtitle">
          {{ item.subtitle }}
        </p>
      </div>
      <p agText="body-3" [style.margin-left]="'auto'">
        {{ item.countryCode }}
      </p>
    } @else {
      <p agText="body-3">
        {{ item.title }}
      </p>
      <p agText="body-3" [style.margin-left]="'auto'">
        {{ item.countryCode }}
      </p>
    }
  } @else if (type === "action") {
    <img [class.destructive]="item.destructive" [src]="item.icon" />
    <p agText="body-3" [class.destructive]="item.destructive">
      {{ item.title }}
    </p>
  } @else if (type === "avatar") {
    <img class="avatar" [src]="item.avatar" />
    @if (item.subtitle) {
      <div class="title-with-subtitle">
        <p agText="body-3">
          {{ item.title }}
        </p>
        <p agText="caption-1" class="subtitle">
          {{ item.subtitle }}
        </p>
      </div>
    } @else {
      <p agText="body-3">
        {{ item.title }}
      </p>
    }
  }
</div>
